import api from './index';
import { buildAdminApiRequest } from './admin';

export type MosaicFetchControl = {
  paused: boolean;
  type: string;
  updatedAt?: string | null;
  updatedBy?: string;
};

const adminAdsureMonitoringApi = api.injectEndpoints({
  endpoints: build => ({
    getMosaicFetchControl: build.query<MosaicFetchControl, void>({
      query: () =>
        buildAdminApiRequest({
          method: 'GET',
          path: '/adsure-monitoring/mosaic-fetch',
        }),
      providesTags: [{ type: 'adminAdsureMonitoring', id: 'MOSAIC_FETCH' }],
    }),
    updateMosaicFetchControl: build.mutation<
      MosaicFetchControl,
      { paused: boolean }
    >({
      query: body =>
        buildAdminApiRequest({
          method: 'PUT',
          path: '/adsure-monitoring/mosaic-fetch',
          body,
        }),
      invalidatesTags: [
        { type: 'adminAdsureMonitoring', id: 'MOSAIC_FETCH' },
      ],
    }),
  }),
});

export const {
  useGetMosaicFetchControlQuery,
  useUpdateMosaicFetchControlMutation,
} = adminAdsureMonitoringApi;
